import { ReactNode, useState, ChangeEvent, useEffect, useRef } from "react";
import styles from "./index.module.css";
import BtnPure from "../btn-pure/index";
import BtnBorder from "../btn-border";
import InputShadow from "../input-shadow/index";
import { CSSTransition } from "react-transition-group";
import trans from "./transition.module.css";

interface EditorProps {
  children?: ReactNode;
  opened: boolean;
  close: () => void;
}


const Editor = (props: EditorProps) => {
  const [message, setMessage] = useState('');
  const { opened, close } = props;
  const [delay, setDelayed] = useState(false);
  const [draftMode, setDraftMode] = useState(false);
  const [selectedEventNav, setSelectedEventNav] = useState(false);
  const nodeRef = useRef(null);
  const handleMessageChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value);
  };

  const changeDraftModeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const target = e.target;
    setDraftMode(target.checked);
  };

  const selectEventNav = () => {
    setSelectedEventNav(true);
  };
  const deselectEventNav = () => {
    setSelectedEventNav(false);
  };

  useEffect(() => {
    setDelayed(true);
  }, [opened]);
  return <>
    <CSSTransition
      nodeRef={nodeRef}
      in={opened && delay}
      timeout={200}
      classNames={{
        enter: trans.panel_enter,
        enterActive: trans.panel_enter_active,
        exit: trans.panel_exit,
        exitActive: trans.panel_exit_active,
      }}
      appear={true}
      unmountOnExit>
      <div className={styles.wrapper} ref={nodeRef}>
        {/* 导航栏 */}
        <ul className={styles.nav}>
          <li className={styles.nav_item}>
            <BtnPure selected={! selectedEventNav} onClick={deselectEventNav}>无名</BtnPure>
          </li>
          <li className={styles.nav_item}>
            <BtnPure selected={selectedEventNav} onClick={selectEventNav}>事件</BtnPure>
          </li>
        </ul>
        {! selectedEventNav && <div className={styles.draft_wrapper}>
          <textarea
            className={`${styles.text_message} groove_shadow`}
            value={message}
            onChange={handleMessageChange} />
          <div className={styles.cbox_wrapper}>
            <label>
              <input style={{verticalAlign: "center"}} type="checkbox" checked={draftMode} onChange={changeDraftModeHandler} />
              速写模式
            </label>
          </div>
          <div className={styles.btn_wrapper}>
            <BtnBorder>发布布</BtnBorder>
          </div>
        </div>}
        {selectedEventNav && <div className={styles.event_wrapper}>
          <label className={`${styles.id_label_wrapper} ${styles.marginTop}`}>
            事件编号
            <InputShadow />
          </label>
          <label className={`${styles.event_label_wrapper} ${styles.marginTop}`}>
            事件密码
            <InputShadow />
          </label>
          <textarea
            placeholder="有什么新鲜事件？"
            className={`${styles.text_message} groove_shadow ${styles.marginTop_2}`}
            value={message}
            onChange={handleMessageChange} />
          <div className={styles.btn_wrapper}>
            <BtnBorder>发布布</BtnBorder>
          </div>
        </div>}
      </div>
    </CSSTransition>
  </>;
};

export default Editor;